export default __webpack_public_path__ + "static/media/img-0431-hungary-full-face.44935765.png";